var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Email templates")]),
      _vm._v(" "),
      _vm.$_can("email-templates.store")
        ? _c(
            "button",
            {
              staticClass: "btn btn-primary",
              attrs: { type: "button" },
              on: { click: _vm.createTemplate }
            },
            [_vm._v("\n    ADD\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.templates
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c("table", { staticClass: "table m-table table-hover" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.templates, function(template) {
                    return _c(
                      "tr",
                      {
                        key: template.id,
                        staticClass: "pointer",
                        on: {
                          click: function($event) {
                            _vm.$_can("email-templates.show") &&
                              _vm.editTemplate(
                                template.company_id,
                                template.email_type_id
                              )
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(template.id))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(template.email_type.name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(template.company.name))]),
                        _vm._v(" "),
                        _c("td")
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.templates && !_vm.templates.length
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "8" }
                          },
                          [_vm._v("\n            No results found\n          ")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ])
          ],
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "modal",
            { attrs: { size: "modal-large" }, on: { close: _vm.closeModal } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h4", [_vm._v("Email template")])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "div",
                        { staticClass: "select-wrap" },
                        [
                          _c("label", [_vm._v("Company")]),
                          _vm._v(" "),
                          _c("simple-select", {
                            attrs: {
                              options: _vm.companies,
                              placeholder: "Select Company"
                            },
                            model: {
                              value: _vm.template.company_id,
                              callback: function($$v) {
                                _vm.$set(_vm.template, "company_id", $$v)
                              },
                              expression: "template.company_id"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "company_id" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "div",
                        { staticClass: "select-wrap" },
                        [
                          _c("label", [_vm._v("Types")]),
                          _vm._v(" "),
                          _vm.template.company_id
                            ? _c("simple-select", {
                                attrs: {
                                  options: _vm.templateTypes,
                                  placeholder: "Select Template Type"
                                },
                                on: { input: _vm.setTemplate },
                                model: {
                                  value: _vm.template.email_type_id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.template, "email_type_id", $$v)
                                  },
                                  expression: "template.email_type_id"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "email_type_id" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("div", { staticClass: "select-wrap" }, [
                        _c("label", [_vm._v("Email subject")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.template.subject,
                              expression: "template.subject"
                            }
                          ],
                          ref: "subject",
                          staticClass: "form-control",
                          domProps: { value: _vm.template.subject },
                          on: {
                            click: function($event) {
                              _vm.addingVariableOn = "subject"
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.template,
                                "subject",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "subject" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("div", { staticClass: "select-wrap h-auto" }, [
                        _c("label", [_vm._v("Email text")]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.template.content,
                              expression: "template.content"
                            }
                          ],
                          ref: "ta",
                          staticClass: "form-control select-wrap-textarea",
                          attrs: {
                            cols: "30",
                            rows: "10",
                            contenteditable: "true"
                          },
                          domProps: { value: _vm.template.content },
                          on: {
                            click: function($event) {
                              _vm.addingVariableOn = "ta"
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.template,
                                "content",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("error-field", {
                        attrs: { errors: _vm.errors, field: "content" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("label", [_vm._v("Variables")]),
                    _vm._v(" "),
                    _vm.template.company_id
                      ? _c(
                          "div",
                          _vm._l(_vm.template.variables, function(
                            variable,
                            key,
                            index
                          ) {
                            return _c(
                              "span",
                              {
                                key: index,
                                staticClass:
                                  "badge badge-primary mx-1 unselectable pointer",
                                on: {
                                  dblclick: function($event) {
                                    _vm.insertVariable(variable)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(key))]
                            )
                          })
                        )
                      : _c("div", { staticClass: "text-danger" }, [
                          _vm._v("* Please select company and template")
                        ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 text-right" }, [
                    _vm.$_can("email-templates.destroy")
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: { type: "button" },
                            on: { click: _vm.deleteTemplate }
                          },
                          [_vm._v("\n            Delete template\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$_can("email-templates.update")
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: { click: _vm.save }
                          },
                          [_vm._v("\n            Save template\n          ")]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" })
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "m-table__heading" }, [
      _c("tr", [
        _c("th", { staticClass: "m-table__id" }, [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Email type")]),
        _vm._v(" "),
        _c("th", [_vm._v("Company")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44fa5be6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44fa5be6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Mailing/EmailTemplates.vue
// module id = null
// module chunks = 